// 공지 폴링 hook (P0-3)
import { useCallback, useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'

export interface Announcement {
  id: string
  title: string
  body: string
  severity: 'info' | 'warning' | 'critical'
  created_at: string
  expires_at: string | null
}

const POLL_INTERVAL_MS = 5 * 60 * 1000 // 5분

export function useAnnouncements() {
  const [items, setItems] = useState<Announcement[]>([])
  const [loading, setLoading] = useState(false)

  const fetchActive = useCallback(async () => {
    setLoading(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const token = session?.access_token
      const headers: HeadersInit = {}
      if (token) headers.Authorization = `Bearer ${token}`
      const r = await fetch('/api/v1/announcements/active', { headers })
      if (r.ok) {
        const data = await r.json()
        setItems(data.announcements ?? [])
      }
    } catch {
      // ignore
    } finally {
      setLoading(false)
    }
  }, [])

  const dismiss = useCallback(async (id: string) => {
    setItems((prev) => prev.filter((a) => a.id !== id))
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const token = session?.access_token
      await fetch('/api/v1/announcements/dismiss', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ announcement_id: id }),
      })
    } catch {
      // ignore — UI에서 이미 제거됨
    }
  }, [])

  useEffect(() => {
    void fetchActive()
    const interval = setInterval(fetchActive, POLL_INTERVAL_MS)
    return () => clearInterval(interval)
  }, [fetchActive])

  return { items, loading, dismiss, refresh: fetchActive }
}
